import classNames from "classnames";
import isNil from "lodash/isNil";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { IconName } from "PFTheme/graphics/icons";

import css from "./booking_detail_boolean_property.module.scss";

const getIconName = (checked?: boolean): IconName => {
  if (isNil(checked)) {
    return "question";
  }
  return checked ? "check" : "cross";
};

type BookingDetailBooleanPropertyProps = {
  checked?: boolean;
  label: string;
  className?: string;
};

export const BookingDetailBooleanProperty = ({
  checked,
  label,
  className
}: BookingDetailBooleanPropertyProps) => (
  <div className={classNames(css.booleanProperty, className)}>
    <Icon name={getIconName(checked)} color="paletteBlue0" />
    <Typography variant="bodyBold" title={label} clipOverflow>
      {label}
    </Typography>
  </div>
);
